<template>
  <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="tableData"
        :fields="fields"
        name="reporteFirmas.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
    <v-toolbar flat color="white">
      <v-toolbar-title>Reporte de documentos firmados</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card>
     <v-layout row wrap>
        <v-flex px-2 xs12 sm4>
          <v-select
            :items="sign_dates"
            v-model="filter_sign"
            label="Filtrar Fecha de firma"
            item-text="description"
            item-value="id"
            clearable
            @change="setFilter"
          ></v-select>
        </v-flex>
        <v-flex px-2 xs12 sm4>
          <v-select
            :items="documents"
            v-model="filter_document"
            label="Filtrar Documento"
            item-text="name"
            item-value="id"
            clearable
            @change="setFilter"
          ></v-select>
        </v-flex>
        <v-flex px-2 xs12 sm4>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        class="the-table"
        :headers="tableHeaders"
        :items="tableData"
        :search="search"
        :loading="loadingTable"
        :custom-sort="customSort"
        :rows-per-page-text="$t('datatable.rowsPerPageText')"
        :no-results-text="$t('datatable.noResultsText')"
        :no-data-text="$t('datatable.noDataText')"
        :rows-per-page-items="[10,20,50,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
      >
        <template slot="items" slot-scope="props">
          <td
            v-for="(head, i) in tableHeaders"
            :key="`t-${i}`"
            :class="[head.document || head.value !== 'full_name' ? 'text-xs-center wrap' : 'nowrap']"
          >
            {{ !head.document ? props.item[head.value] : '' }}
            <v-icon
                v-if="head.document && props.item[`${head.value}`] && props.item[`${head.value}`].split(',')[0] == ''"
                medium
                title="Sin firmar"
                color="grey"
              >
              remove_circle
            </v-icon>
            <v-icon
              v-else-if="head.document && props.item[`${head.value}`] && props.item[`${head.value}`].split(',')[0] == 'F'"
              medium
              title="Firmado"
              color="success"
              @click="loadDocument(props.item[`${head.value}`].split(',')[1])"
            >
              check_circle
            </v-icon>
            <v-icon
              v-else-if="head.document && props.item[`${head.value}`] && props.item[`${head.value}`].split(',')[0] == 'P'"
              medium
              title="Pendiente"
              color="warning"
            >
              info
            </v-icon>
            <v-icon
              v-else-if="head.document"
              medium
              title="N/A"
              color="error"
              >
              highlight_off
            </v-icon>
          </td>
        </template>
        <template v-slot:pageText="props">
          {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="dialogDigitalSign"
      fullscreen>
      <digital-sign-comp
        v-on:closeDialog="closeSignDialog"
        :studentId="''"
        :documentId="0"
        :action="action"
        :processId="0"
        :recordId="vista_record_id"
      ></digital-sign-comp>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import JsonExcel from 'vue-json-excel'
  import DigitalSignComponent from './digital_sign'
  export default {
    name: 'employee-sign-report',
    components: {
      'digital-sign-comp': DigitalSignComponent,
      'download-excel': JsonExcel,
    },
    data() {
      return {
        sign_dates: [],
        filter_sign: '',
        filter_document: '',
        students: [],
        documents: [],
        tableHeaders: [],
        tableData: [],
        search: '',
        dialogDigitalSign: false,
        vista_record_id: 0,
        action: '',
        fields: {},
      }
    },
    computed: {
      
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        this.loadingTable = true
        let payload = ""
        // if (this.filter_document != ''){
        //   payload = "document_id="+this.filter_document
        // }
        // if (this.filter_sign != ''){
        //   payload = "date_sign_id="+this.filter_document
        // }
        axios.get(`/api/documents/sign_date/students/report?${payload}`)
          .then(resp => {
            if (resp.status === 200) {
              this.students = resp.data.students
              this.documents = resp.data.documents
              this.loadingTable = false
              this.setData()
              this.setFilter()
            }
          })
          .catch(err => console.log(err))
        axios.get('/api/documents/sign_dates')
        .then(resp => {
          if (resp.status === 200) {
            this.sign_dates = resp.data.filter(data => data.type == 'STU');
            this.loadingTable = false
          }
        })
      },
      setData() {
        this.loadingTable = true
        let headers = []

        this.fields = {
          'Estudiante': 'full_name',
          'Cód. de fam.': 'family_id',
          'Cód. Est.': 'student_number',
          'Grado': 'grade_level',
        }

        headers.push(
          { text: 'Estudiante', align: 'start', value: 'full_name', document: false, width: '280px' },
          { text: 'Cód. de fam.', align: 'center', value: 'family_id', document: false },
          { text: 'Cód. Est.', align: 'center', value: 'student_number', document: false },
          { text: 'Grado', align: 'center', value: 'grade_level', document: false },
        )

        this.documents.forEach(document => {
          headers.push(
            {
              text: document.name,
              align: 'center',
              value: "doc_"+document.id,
              document: true,
              width: "150px",
              orderable: true,
              class: 'wrap',
            }
          )
          this.fields = {
            ...this.fields,
            [`${document.name}`]: `doc_${document.id}`,
          }
        })

        this.tableHeaders = headers
        this.loadingTable = false
      },
      setFilter() {
        this.loadingTable = true
        let data = this.students
        if (this.filter_document && this.filter_document !== ""){
          data = data.filter( x => 
            x[`doc_${this.filter_document}`]
          )
        }
        if (this.filter_sign && this.filter_sign !== ""){
          data = data.filter( x => 
            x[`date_sign_${this.filter_sign}`] > 0
          )
        }
        this.tableData = data
        this.loadingTable = false
      },
      customSort(items, index, isDescending) {
        items.sort((a, b) => {
          if (a[`${index}`] == null) a[`${index}`] = ''
          if (b[`${index}`] == null) b[`${index}`] = ''
          if (isDescending) {
              return b[`${index}`].localeCompare(a[`${index}`]);
          } else {
              return a[`${index}`].localeCompare(b[`${index}`]);
          }
        });
        return items;
      },

      loadDocument(doc_id) {
        this.dialogDigitalSign = true
        this.action = 'SHOW'
        this.vista_record_id = doc_id
      },
      closeSignDialog() {
        this.action = ''
        this.dialogDigitalSign = false
      }
    },
  }
</script>





// WEBPACK FOOTER //
// resources/assets/js/pages/documents/students_sign_report.vue